<script lang="ts">
  import { t } from '$lib/i18n';
  import { boardShortcutDate, type BoardDateShortcut } from '$lib/utils/board';
  let { value = $bindable(''), label }: { value: string; label?: string } = $props();
  const shortcuts: BoardDateShortcut[] = ['today', 'tomorrow', 'friday', 'monday'];
</script>

<label class="label">{label ?? t('board.due.optional')}<input type="date" class="input mt-1 min-h-[44px]" bind:value /></label>
<div class="mt-2 flex flex-wrap gap-2" role="group" aria-label={label ?? t('board.due.label')}>
  {#each shortcuts as shortcut}
    <button type="button" class="btn-secondary min-h-[44px] !px-3 !text-xs" aria-pressed={value === boardShortcutDate(shortcut)} onclick={() => value = boardShortcutDate(shortcut)}>{t(`board.date.${shortcut}`)}</button>
  {/each}
</div>
